<template>
  <div class="text-field">
    <div
      class="m-form-element js-m-form-element"
      :class="{'state-m-form-element--input-error': v$[slug] && v$[slug].$error}"
    >
      <div class="a-text-input js-a-text-input">
        <div
          class="a-text-input__input js-a-text-input__input"
        >
          <input
            :id="slug"
            v-maska="'##/##/####'"
            placeholder="__/__/____"
            type="text"
            :name="slug"
            :value="model"
            :data-cy="slug"
          >
        </div>
        <label
          class="a-text-input__label js-a-text-input__label"
          :for="slug"
        >
          {{ label }}
        </label>
      </div>

      <!-- Message d'erreur -->
      <ErrorMessage :validation-status="v$[slug]" />
    </div>
  </div>
</template>

<script>

import ErrorMessage from "./ErrorMessage";

export default {
  name: "InputTextDate",
  components: {
    ErrorMessage
  },
  props: {
    label: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    /**
     * Date au format (DD/MM/YYYY)
     */
    model: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    v$: {
      type: Object,
      required: true
    }
  },
  setup() {
  }
}
</script>

<style lang="scss" scoped>

#app .a-text-input__label {
  font-family: "Calibri W02 Regular",Arial,Helvetica,sans-serif;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: .4px;
  padding-right: 0;
  top: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-decoration: none;
}

::v-deep(input) {
  border: none;
  -webkit-appearance: none;
  appearance: none;
  outline: none;
}
.icon-calendar {
  background-position: center;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' id='field-date-picker-20' viewBox='0 0 20 20'%3E%3Cg id='icons'%3E%3Cpath class='st13' d='M5.5 1H5c-.3 0-.5.2-.5.5V5c0 .3.2.5.5.5h.5c.3 0 .5-.2.5-.5V1.5c0-.3-.2-.5-.5-.5zM15 1h-.5c-.3 0-.5.2-.5.5V5c0 .3.2.5.5.5h.5c.3 0 .5-.2.5-.5V1.5c0-.3-.2-.5-.5-.5zM9.5 8c0 .3-.2.5-.5.5H7.5c-.3 0-.5-.2-.5-.5v-.5c0-.3.2-.5.5-.5H9c.3 0 .5.2.5.5V8zM6 10.5c0 .3-.2.5-.5.5H4c-.3 0-.5-.2-.5-.5V10c0-.3.2-.5.5-.5h1.5c.3 0 .5.2.5.5v.5zM9.5 10.5c0 .3-.2.5-.5.5H7.5c-.3 0-.5-.2-.5-.5V10c0-.3.2-.5.5-.5H9c.3 0 .5.2.5.5v.5zM13 10.5c0 .3-.2.5-.5.5H11c-.3 0-.5-.2-.5-.5V10c0-.3.2-.5.5-.5h1.5c.3 0 .5.2.5.5v.5zM6 13c0 .3-.2.5-.5.5H4c-.3 0-.5-.2-.5-.5v-.5c0-.3.2-.5.5-.5h1.5c.3 0 .5.2.5.5v.5zM9.5 13c0 .3-.2.5-.5.5H7.5c-.3 0-.5-.2-.5-.5v-.5c0-.3.2-.5.5-.5H9c.3 0 .5.2.5.5v.5zM13 13c0 .3-.2.5-.5.5H11c-.3 0-.5-.2-.5-.5v-.5c0-.3.2-.5.5-.5h1.5c.3 0 .5.2.5.5v.5zM16.5 10.5c0 .3-.2.5-.5.5h-1.5c-.3 0-.5-.2-.5-.5V10c0-.3.2-.5.5-.5H16c.3 0 .5.2.5.5v.5zM13 8c0 .3-.2.5-.5.5H11c-.3 0-.5-.2-.5-.5v-.5c0-.3.2-.5.5-.5h1.5c.3 0 .5.2.5.5V8zM16.5 8c0 .3-.2.5-.5.5h-1.5c-.3 0-.5-.2-.5-.5v-.5c0-.3.2-.5.5-.5H16c.3 0 .5.2.5.5V8zM13 3.5c0 .3-.2.5-.5.5h-5c-.3 0-.5-.2-.5-.5V3c0-.3.2-.5.5-.5h5c.3 0 .5.2.5.5v.5z'%3E%3C/path%3E%3Cpath class='st13' d='M18.8 2.5H17c-.3 0-.5.2-.5.5v.5c0 .3.2.5.5.5h1v11H2V4h1c.3 0 .5-.2.5-.5V3c0-.3-.2-.5-.5-.5H1.2c-.4 0-.8.3-.8.8v12.5c0 .4.3.8.8.8h17.5c.4 0 .8-.3.8-.8V3.2c0-.4-.3-.7-.7-.7z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E%0A");  background-repeat: no-repeat;
}

</style>
